var pathSh1 = meta.page.pageType;

if (pathSh1.includes('cart')) {
  document.querySelectorAll('.cart-item__variants dl div').forEach(div => {
    const dt = div.querySelector('dt');
    if (dt && dt.textContent.includes('Combination')) {
      div.style.display = 'none';
    }
  });
}

if (pathSh1.includes('product')) {
  // Safe back_forward reload handling
  var navEntries = performance && performance.getEntriesByType ? performance.getEntriesByType("navigation") : [];
  if (navEntries.length && navEntries[0].type === "back_forward") {
    if (!sessionStorage.getItem('bf_reloaded')) {
      sessionStorage.setItem('bf_reloaded', 'true');
      location.reload();
    }
  } else {
    sessionStorage.removeItem('bf_reloaded');
  }

  // const productId = meta.product.id;
  // localStorage.removeItem(`${productId}_croppedData`);
  const productId = meta.product.id;

var productTag = document.getElementsByClassName('livearf-product-tags')[0]?.getAttribute("data-tags") || "";

if (!productTag.includes('upload')) {
    localStorage.removeItem(`${productId}_croppedData`);
}
  
  var variantSelects = document.querySelector('variant-selects');
  var livearfVariantSelects = document.querySelector('livearf-variant-selects');
  if (livearfVariantSelects && variantSelects) {
    livearfVariantSelects.after(variantSelects);
  }
  
  const sizeLegend = document.querySelector('variant-selects > fieldSet[name="Size"] > legend, variant-selects > fieldSet[name="Size"] > span');
  if (sizeLegend) sizeLegend.innerText = "Choose Size";

  const frameView = document.getElementById('frameView');
  if (frameView) frameView.style.display = 'none';

  const galleryView = document.getElementById("galleryView");
  var productTag = document.getElementsByClassName('livearf-product-tags')[0]?.getAttribute("data-tags") || "";

  if (productTag.includes('upload') && galleryView) {
    galleryView.style.display = 'none';    
  }
  if (productTag.includes('photo-prints')) {
    document.getElementById('livevue-Template')?.classList.add('photo-prints-layout');
  }

  
if (productTag.includes('upload')) {
    document.getElementById('livevue-Template')?.classList.add('photo-prints-layout');

    // Use the current product's cropped-data key
    var cropDataKey = meta.product.id + '_croppedData';

    function checkPhotoPrintImage() {
        var croppedData = localStorage.getItem(cropDataKey);
        var imageUploaded = false;

        if (croppedData) {
            try {
                var parsedData = JSON.parse(croppedData);

                imageUploaded = !!(
                    parsedData &&
                    parsedData.value &&
                    parsedData.value.originalImage
                );
            } catch (e) {
                imageUploaded = false;
            }
        }

        var addToCartBtn = document.querySelector(
            'button[name="add"].product-form__submit'
        );

        if (addToCartBtn) {
            addToCartBtn.disabled = !imageUploaded;
            addToCartBtn.style.opacity = imageUploaded ? '1' : '0.5';
            addToCartBtn.style.cursor = imageUploaded ? 'pointer' : 'not-allowed';
        }
    }

    // Check immediately and continue checking while the cropper updates storage
    checkPhotoPrintImage();

    setInterval(checkPhotoPrintImage, 1000);

    var imageUploadInput = document.getElementById('image-upload');

    if (imageUploadInput) {
        imageUploadInput.addEventListener('change', function () {
            setTimeout(checkPhotoPrintImage, 500);
        });
    }
}


    // Check when the page loads
    // checkPhotoPrintImage();

    // Check when the user selects an image
    if (imageUploadInput) {
        imageUploadInput.addEventListener('change', function () {
            setTimeout(checkPhotoPrintImage, 500);
        });
    }

    // Check after the image upload/crop process updates localStorage
    setInterval(checkPhotoPrintImage, 1000);
}

  // Photo Repair Icon
  const photoRepairLegend = document
    .querySelector('input[option_name="Photo Repair"]')
    ?.closest('fieldset')
    ?.querySelector('legend');

  if (photoRepairLegend && !photoRepairLegend.querySelector('.image-upscale-info-icon')) {
    const icon = document.createElement('img');
    icon.src = 'https://cdn.shopify.com/s/files/1/0769/7029/5518/files/output-onlinepngtools.png?v=1775023360';
    icon.className = 'image-upscale-info-icon';
    icon.style.cssText = 'width:24px; height:24px; object-fit:contain; cursor:pointer;';
    icon.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      window.open('https://canvasartbarn.com/pages/photo-repair-service', '_blank');
    });
    photoRepairLegend.appendChild(icon);
  }

  const priceContainer = document.getElementById("larf-price");
  if (priceContainer) {
    const currencyRegex = /\s?[A-Z]{3}\b/g;
    priceContainer.querySelectorAll(".price-item, .livevue-display-price, .livevue-discount-price").forEach(el => {
      el.textContent = el.textContent.replace(currencyRegex, "");
    });
  }

  document.querySelectorAll('.product__media').forEach(media => {
    media.childNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === '.') {
        node.remove();
      }
    });
  });

  const galleryBtn = document.getElementById("galleryView");
  if (galleryBtn) {
    galleryBtn.click();
    const galleryImages = document.querySelectorAll(".gallery-preview-images");
    if (galleryImages.length > 1) {
      galleryImages[1].click();
    }
  }

  document.getElementById("roomView")?.addEventListener("click", function () {
    setTimeout(() => {
      const el = document.getElementById("draggableContainer");
      if (el && el.parentElement) {
        const parent = el.parentElement;
        const left = (parent.offsetWidth - el.offsetWidth) * 0.5;
        const top = (parent.offsetHeight - el.offsetHeight) * 0.25;
        el.style.left = `${left}px`;
        el.style.top = `${top}px`;
      }
    }, 1000);
  });

  // ⚠️ SAFE INTERVAL: Triggers calculation instead of location.reload()
  setInterval(() => {
    const priceEl = document.querySelector('.livevue-display-price');
    if (priceEl) {
      const price = parseFloat(priceEl.innerText.replace(/[^0-9.]/g, ''));
      if (price === 0 && typeof getSelectedData === 'function') {
        getSelectedData(); // Re-calculate pricing safely instead of reloading page
      }
    }
    const selected = document.querySelector('#previewIcons li.selected');
    if (!selected) {
      document.getElementById('galleryView')?.click();
    }
  }, 1000);

  document.querySelectorAll('input[action]').forEach(el => {
    if (!document.querySelector(`input[name="${el.name}"]:checked`)) {
      el.click();
    }
  });

  function syncFrameProfiles() {
    window.frameProfiles = window.frameProfiles || {};
    document.querySelectorAll('input[profile-id][data-frame-url]').forEach(input => {
      const profileId = input.getAttribute('profile-id');
      const frameUrl = input.getAttribute('data-frame-url');
      if (profileId && frameUrl) {
        if (!window.frameProfiles[profileId]) {
          window.frameProfiles[profileId] = {
            profile_path: btoa('M 0 0 L 10 0 L 10 10 L 0 10 Z'),
            front_texture: frameUrl,
            side_texture: frameUrl
          };
        } else if (!window.frameProfiles[profileId].front_texture) {
          window.frameProfiles[profileId].front_texture = frameUrl;
        }
      }
    });
  }

  syncFrameProfiles();

  document.addEventListener('change', function (e) {
    if (e.target && e.target.hasAttribute('profile-id')) {
      syncFrameProfiles();
    }
  }, true);

  document.addEventListener('click', function (e) {
    if (e.target && (e.target.id === 'reset_button' || e.target.closest('#reset_button'))) {
      if (typeof cropper !== 'undefined' && cropper) {
        cropper.reset();
        let targetRatio = 1;
        if (typeof currentSize !== 'undefined') {
          targetRatio = currentSize.ratio || (currentSize.width && currentSize.height ? currentSize.width / currentSize.height : 1);
        }
        if (cropper.setAspectRatio) {
          cropper.setAspectRatio(targetRatio);
        }
        if (typeof croppedData !== 'undefined' && currentSize?.ratio) {
          delete croppedData[currentSize.ratio];
        }
        if (typeof croppedDataV2 !== 'undefined') {
          croppedDataV2 = {
            ...cropper.getData(true),
            originalImage: typeof IMAGE_URL !== 'undefined' ? IMAGE_URL : (croppedDataV2?.originalImage || '')
          };
        }
        if (typeof selectedOptionData === 'function') {
          selectedOptionData();
        }
      }
    }
  });

  function setDefaultFrame() {
    syncFrameProfiles();
    const frameFieldset = document.querySelector('fieldset[name="Choose Frame"]');
    if (!frameFieldset) return;
    const selected = frameFieldset.querySelector('input[type="radio"]:checked');
    if (selected) return;
    const natural = frameFieldset.querySelector('input[value="Natural"]');
    if (natural) {
      natural.checked = true;
      natural.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  setDefaultFrame();
  document.querySelectorAll('.form__label').forEach(el => {
    if (el.textContent.trim() === 'Image upload') {
        el.textContent = 'Image Upload';
    }
});
setTimeout(() => {
  document.addEventListener('change', function (e) {
  if (e.target && e.target.closest('livearf-variant-selects')) {
    document.getElementById('threeDView')?.click();
  }
});
}, 1500);

